module.exports = __webpack_public_path__ + "media/icons/arrow-btn-baner-f0f38ded.png";